module.exports = __webpack_public_path__ + "static/media/fi-rr-calendar.565e812c.svg";